const app = require('app');
app.init();

if (import.meta.webpackHot) {
    import.meta.webpackHot.accept();
}

